module.exports = __webpack_public_path__ + "img/caasa.f24530c5.png";